import { computed, inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UsersStore } from '@data-access/user/stores/users.store';
import { firstValueFrom } from 'rxjs';
import { PlanSelectDialog } from '@shared/components/plan-select-dialog/plan-select-dialog';
import { InfoDialog } from '@shared/components/info-dialog/info-dialog';

@Injectable({providedIn: 'root'})
export class DemoUserHandler {
  readonly dialog = inject(MatDialog);
  readonly userStore = inject(UsersStore);

  initialMessageShown = computed(() => {
    return this.userStore.initialMessageShown();
  })
  // is plan selection modal after login shown


  // if demoOnly is true - will check and show only cases if plan is not selected
  async isUserValid(demoOnly = false) {
    if (this.userStore.user()!.subscriptionStatus === null) {
      await this.selectSubscription();
      return false;
    }

    if (this.userStore.user()!.subscriptionStatus !== 'active') {

      const subscriptionStatus: {ok: boolean; status: number; error: { error?: string }} = await this.userStore.getCurrentSubscription(demoOnly);

      if (!subscriptionStatus.ok) {

        // no card stored
        if (subscriptionStatus.status === 402 && subscriptionStatus.error.error === 'SUBSCRIPTION_REQUIRED_NO_PAYMENT_METHOD') {
          await this.selectSubscription();
          return false;
        }

        if (demoOnly) {
          return true;
        }

        if (subscriptionStatus.status === 402 && subscriptionStatus.error.error === 'SUBSCRIPTION_REQUIRED_PENDING_APPROVAL') {
          await this.incorrectSubscriptionMessage('Pending Verification', 'Your submission is complete and awaiting final approval.');
          return false;
        }

        await this.selectSubscription();
          // await this.incorrectSubscriptionMessage('Subscription error',
          //   `Application approved. Payment declined. Please update your payment to access downloads. For help, contact support <a href="/contact-us" style="text-decoration: none; color: var(--mat-sys-primary);">link</a>`);

        return false;
      }
      // else sub is ok
    }

    return true;
  }

  async selectSubscription() {
    this.userStore.setInitialMessage(true);
    const plans = await firstValueFrom(this.userStore.getPlans());
    const dialogRef = this.dialog.open(PlanSelectDialog, {
      data: {
        plans: plans,
        showCancel: true,
        showPromoField: true
      },
      disableClose: true,
      width: '85%',
      maxWidth: '1500px',
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      const res =  await this.userStore.startSubscription(result.planId, result.promoCode);

      if (res && res.checkoutUrl) {

        window.location.replace(res.checkoutUrl);
      }
    }

  }

  async incorrectSubscriptionMessage(title: string, message: string) {
    const dialogRef = this.dialog.open(InfoDialog, {
      data: {
        title: title,
        message: message
      },
      disableClose: true,
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });
    return firstValueFrom(dialogRef.afterClosed());
  }
}
